export class ServerError {
  constructor(
    public type: string,
    public message: string,
    public action: string,
  ) {}
}
